import { Checkbox, FormControlLabel, FormGroup, Grid, Stack, Tooltip, Typography } from '@mui/material'
import React from 'react'
import ListIcon from '@mui/icons-material/List'

function HeaderSelection({ sumInsuredData, checkIsSelected, selecthead }) {
    return (
        <Grid container spacing={2}>
            {sumInsuredData?.missingHeaders?.length > 0 ? (
                sumInsuredData.missingHeaders.map((heads, index) => (
                    <Grid item xs={3} key={index}>
                        <Stack direction="row">
                            <FormGroup>
                                <Tooltip
                                    title={`Data Type: ${heads?.sumInsuredHeader?.dataType}`}
                                    arrow
                                >
                                    <FormControlLabel
                                        style={{ textTransform: "capitalize" }}
                                        control={
                                            <Checkbox
                                                checked={checkIsSelected(heads)}
                                                onChange={() => selecthead(heads)}
                                            />
                                        }
                                        label={heads?.title}
                                    />
                                </Tooltip>
                            </FormGroup>
                            {heads.masterDataCheck && (
                                <div style={{ marginTop: "10px" }}>
                                    <ListIcon />
                                </div>
                            )}
                        </Stack>
                    </Grid>
                ))
            ) : (
                <Grid item xs={12}>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ textAlign:'center', mt: 2 }}
                    >
                        No headers available. Please add headers in the template section to
                        reflect here.
                    </Typography>
                </Grid>
            )}
        </Grid>

    )
}

export default HeaderSelection